// extracted by mini-css-extract-plugin
module.exports = {"container":"gc-z","copy":"hc-z","field":"ic-z","error":"jc-z","disabled":"kc-z","termsContainer":"lc-z","termsHeading":"mc-z","termsCopy":"nc-z","submit":"oc-z","srOnly":"pc-z"};